import React from 'react';
import defaultImage from '@/assets/images/placeholders/show-course.jpg';
import { AiOutlineTrophy } from 'react-icons/ai';
import * as Fi from 'react-icons/fi';
import { t } from 'i18next';
import { Sheet, SheetBody, SheetContent, SheetTitle } from '@/components/ui/sheet';
import {
  Certificate,
  CertificateBody,
  CertificateFooter,
  CertificateHeader,
  CertificateHeaderContent,
  CertificateIcon,
  CertificateImg,
  CertificateKpi,
  CertificateKpiContent,
  CertificateKpiLabel,
  CertificateKpis,
  CertificateKpiValue,
  CertificateLogo,
  CertificateText,
  CertificateTitle
} from '@/components/custom/certificate';

export function CourseCertificateModal(props) {
  const { show, onClose, currentCertificate } = props;

  const appName = process.env.REACT_APP_NAME;
  const logo = require(`@/assets/images/${appName}/horizontal-logo.svg`);
  const certificateDate = currentCertificate?.['created-at'];
  const parts = certificateDate?.split('/');
  const day = parseInt(parts?.[0]);
  const month = parseInt(parts?.[1]);
  const year = parseInt(parts?.[2]);
  const monthsNames = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
  const monthName = monthsNames[month - 1];
  const formattedDate = `${day} de ${monthName} de ${year}`;

  function getIcon(icon) {
    switch (icon) {
      case 'FiVideo':
        return <Fi.FiVideo className="w-5 flex-shrink-0 text-primary" />;
      case 'FiMousePointer':
        return <Fi.FiMousePointer className="w-5 flex-shrink-0 text-primary" />;
      case 'FiEdit3':
        return <Fi.FiEdit3 className="w-5 flex-shrink-0 text-primary" />;
      case 'FiCheckCircle':
        return <Fi.FiCheckCircle className="w-5 flex-shrink-0 text-primary" />;
    }
  }

  function getEnvName() {
    switch (appName) {
      case 'unisescoop':
        return 'Unisescoop';
      case 'demo':
        return 'Demonstração';
      case 'encceja':
        return 'Pré-Encceja';
      case 'quartosecretariado':
        return 'Quarto Secretariado';
      case 'retina':
        return 'Projeto Retina';
      case 'iesb':
        return 'IESB';
      case 'siape':
        return 'Siape';
      case 'fic':
        return 'FIC';
      case 'brasilstartups':
        return 'Brasil Startups';
      case 'estudologia':
        return 'Estudologia';
      case 'inkluziva':
        return 'inkluziva';
      case 'canaleducacao':
        return 'canaleducacao';
      case 'egepi':
        return 'egepi';
      case 'seducpi':
        return 'seducpi';
      case 'oros':
        return 'oros';
      case 'sett-solutions':
        return 'Sett Solutions';
      case 'aprovavp':
        return 'Aprova VP';
    }
  }

  return (
    <Sheet
      open={show}
      onOpenChange={onClose}
    >
      <SheetContent size="lg">
        <SheetTitle className="sr-only">Certificado</SheetTitle>

        <SheetBody className="p-10">
          <Certificate>
            <CertificateHeader>
              <CertificateImg src={defaultImage} />
              <CertificateLogo src={logo} />
              <CertificateHeaderContent>
                <CertificateTitle>{t('lms.certificateTitle')}</CertificateTitle>
                <CertificateIcon>
                  <AiOutlineTrophy />
                </CertificateIcon>
              </CertificateHeaderContent>
            </CertificateHeader>

            <CertificateBody>
              <CertificateText
                dangerouslySetInnerHTML={{
                  __html: t(currentCertificate?.['certificate-type'] === 'Curso' ? 'lms.certificateTextCourse' : 'lms.certificateText', {
                    userName: currentCertificate?.user.name,
                    moduleTitle: currentCertificate?.['learning-system']?.title,
                    courseTitle: currentCertificate?.['learning-system']?.course.title,
                    day,
                    monthName,
                    year,
                    formattedDate,
                    envName: getEnvName()
                  })
                }}
              />

              <CertificateKpis>
                {currentCertificate?.info.map(item => {
                  return (
                    <CertificateKpi key={item.label}>
                      {getIcon(item.icon)}
                      <CertificateKpiContent>
                        <CertificateKpiValue>{item.count}</CertificateKpiValue>
                        <CertificateKpiLabel>{item.label}</CertificateKpiLabel>
                      </CertificateKpiContent>
                    </CertificateKpi>
                  );
                })}
              </CertificateKpis>

              <CertificateText>
                <small>{t('lms.certificateTextSmall')}</small>
              </CertificateText>
            </CertificateBody>

            <CertificateFooter>
              <CertificateText>
                <small>
                  Brasília,
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t('datesForm.formattedDate', {
                        day: day,
                        monthName: monthName,
                        year: year
                      })
                    }}
                  />
                </small>
              </CertificateText>
            </CertificateFooter>
          </Certificate>
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
}
